import { ValueOf } from 'type-fest';

import { styled, theme } from '../stitches.config';
import { rem, Scale } from '../util';

type Color = ValueOf<typeof theme.colors>;

export const Spacer = ({
  height,
  width,
  backgroundColor,
}: {
  height: Scale;
  width?: Scale;
  backgroundColor?: Color;
}) => {
  return (
    <Div
      css={{
        flexShrink: 0,
        height: rem(height),
        width: width ? rem(width) : 'unset',
        backgroundColor: backgroundColor,
      }}
    />
  );
};

const Div = styled('div', {});
